import React, { useState } from "react";

import classes from "./styles.module.scss";

import InfoIcon from "assets/images/icons/info.svg";
import ArrowDown from "~assets/images/icons/JSX/arrow-down";

const Information = ({ currentStep, goBack }) => {
    const [showInfo, setShowInfo] = useState(false);

    return (
        <div
            style={{
                margin: "19px 0",
                padding: "0 45px",
            }}
        >
            <div className={classes.informationContainer}>
                <div
                    style={{
                        cursor: currentStep !== "step_1" ? "pointer" : "default",
                    }}
                    className={`${classes.informationGoBackWrapper} ${
                        currentStep === "step_1" ? classes.informationGoBackWrapperHidden : ""
                    }`}
                    onClick={() => {
                        if (currentStep !== "step_1") goBack();
                    }}
                >
                    <ArrowDown fill="#92A4AD" style={{ transform: "rotate(90deg)" }} />
                    <span>Back</span>
                </div>
                <div
                    className={`${classes.informationWrapper} ${
                        showInfo ? `${classes.activeInfo} ${classes.showArrow}` : ""
                    }`}
                    onClick={() => setShowInfo((prev) => !prev)}
                >
                    <img src={InfoIcon} alt="InfoIcon" />
                    <span>Information</span>
                </div>
            </div>
            <div className={`${classes.info} ${showInfo ? classes.showInfo : ""}`}>
                <p>
                    Use credits to unlock <strong>Insights</strong> (1 credit per activated model) and{" "}
                    <strong>Parametric Analysis</strong> runs (1 credit per 2,500 runs). Credits are non-refundable and
                    cannot be retrieved after they have been used to unlock app features.
                </p>
            </div>
        </div>
    );
};

export default Information;
